const applicant = function () {

    var currentProfile = Esearcher.Helper.url.getParameterValue('profileId');
    var highlightTabsForProfile = function (doHighlight) {

        var method = doHighlight ? 'addClass' : 'removeClass';

        $('a[href="#job"], a[href="#cv"], a[href="#internalProfile"], a[href="#skills"]')
                .parent()[method]('editingNonDefaultProfile');
    };

    $(document).on('click', '#changeApplicantPicBtn', function() {
        $('.blockPictureDialog').dialog({
            title: $('#changeApplicantPicBtn').val(),
            modal: true,
            width: 'auto',

            buttons: [{
            html: "Schlie&szlig;en",
            click: function() {
                    $(this).dialog('close');
                }
            }]
       });
    });

    $(document).on('click', '#profileLink', function () {

        var profileType = $('#profilTypId').val();
        var profileId = $('#profilId').val();

        window.open('/applicant/profile/' +
                profileType + '/' + profileId, '_blank');
    });

    $(document).on('change', '.applicantWriteDocument', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var dataElement = $(e.currentTarget).find(":selected");
        var target = '/write_stddok.php?did=' + dataElement.data('actionId') + '&kid=' + $('#dataId').val();

        if (dataElement.data('actionType') === 'draft') {
            target = '/write_stddok.php?draftid=' + dataElement.data('actionId');
        }

        Esearcher.Helper.navigation.redirect(dataElement.data('backUrl'), target);
    });

    $(document).on('click', '#newCvEntryButton', function() {

        var form = new Esearcher.Helper.Form('cvForm');

        form.reset('editId', 'kind', 'placeWhere', 'positionDegree',
                'periodMonthBegin', 'periodMonthEnd', 'periodYearBegin',
                'periodYearEnd', 'industry', 'description')
            .get('kind').trigger('focus');
    });

    $(document).on('click', '.sortCvChronologically', function() {
        crm.showTabOverlay();

        var userId = $('#dataId').val();
        var profileId = $('#cvFormProfileId').val();

        if(profileId === undefined){
            profileId = 0;
        }

        $.post("/applicant/tab/cv/table/sortable/save-cv-chronologically/" + userId + "/" + profileId)
            .done(function(data) {
                if(data.table){
                    const tableSortable = $(data.table).find('#tableSortable');
                    $("#tableSortable").replaceWith(tableSortable);

                    if (tableSortable.length){
                        new SortableTable(tableSortable);
                    }
                }
                crm.hideTabOverlay();
            });
    });

    // "Kandidatenprofile mergen"-Popup
    $(document).on('click', '.applicantMergeInternalProfileButton', function(e) {
            var me = $(this);

            var dialog = $('<iframe id="externalSite" class="externalSite" ' +
                'border="0" style="border:0px;" src="' + me.attr('data-merge-url') + '" />');
            dialog.dialog({
                title: me.attr('title') ? me.attr('title') : 'External Site',
                width: 1000,
                height: 600,
                modal: true,
                buttons: [{
                    class: 'modal-icon closeIcon',
                    position: '.modal-buttons',
                    'click': function () {
                        dialog.dialog('destroy');
                    }
                }]
            });
    });

    if (currentProfile) {
        highlightTabsForProfile(true);
    }

    /**
     * If the documents type changes in the documents form, then the correct allowed file types are set for the file uploader.
     */
    $(document).on('change', '#documentsForm #documentsFormDocumentType', function() {
        var documentsForm = $('#documentsForm');
        var docType = parseInt(documentsForm.find('#documentsFormDocumentType').val());
        var applicantId = parseInt($('#dataId').val());
        var fileUploaderId = documentsForm.find('.fileuploaderId').val();

        if(docType > 0) {
            $.ajax({
                type: "POST",
                url: '/applicant/tab/document/change-doctype/' + applicantId + '/' + docType + '?fileuploaderId=' + fileUploaderId,
                loadingOverlay: true
            }).done(function (data) {
                // Replace the html with the new allowed file types string.
                documentsForm.find('.allowedFileTypes').html(data.allowedFileTypes);

                // We have to remove all uploaded files after changing the file type, because it could be that one of the already uploaded files is part of the new not allowed file types.
                documentsForm.find('.deleteFile').each(function() {
                    var defaultFileUploaderWidget = widget.getById(documentsForm.find('[widget="esearcher.fileuploader_defaultFileuploader"]').attr('widgetid'));
                    defaultFileUploaderWidget.deleteFile($(this));
                });
            });
        }
    });

    $(document).on('click', '.createDummyEmailAddress', function () {
        createDummyMailAdress();
    });

    function createDummyMailAdress (){
        $.ajax({
            url: '/applicant/get-dummy/email-address',
            method: 'POST',
            dataType: 'json',
            success: function (data) {
                $('#applicantFormEmail').val(data.email);
            }
        });
    }
};

export default applicant;
